<template>
  <ChatModal
    :name="$options.name"
    :title="$t('share')"
    @before-open="beforeOpen"
  >
    <div slot="default" :class="$style.container">
      <Spinner v-if="isSubmiting" :class="$style.spinner" />
      <template v-else>
        <div :class="$style.header">
          <CopyButton :value="value" :class="$style.copy">{{ $t('copy') }}</CopyButton>
          <BaseInput v-model="text" multiline rows=5 />
        </div>
        <SearchInput
          v-model="searchQuery"
          :class="$style.searchInput"
          @clear="resetQuery"
        />
        <div :class="$style.list">
          <div v-if="!isFetched && !displayList.length">
            <SidebarContentLoader />
            <SidebarContentLoader />
            <SidebarContentLoader />
          </div>
          <ChatListItem
            v-for="chat in displayList" :key="chat.id"
            :chat="chat"
            @click.native="send(chat.id)"
          />
        </div>
      </template>
    </div>
  </ChatModal>
</template>

<script>
import ChatModal from './ChatModal'
import ChatListItem from '@/views/Messenger/chat/ChatListItem'
import Spinner from '@/components/Spinner'
import { mapGetters, mapActions } from 'vuex'
import SearchInput from '@/components/SearchInput'
import CopyButton from '@/components/CopyButton'
import SidebarContentLoader from '@/components/SidebarContentLoader'
import { TYPE_CODE } from '@/models/Message'

export default {
  name: 'share-to-chat',
  components: {
    ChatModal,
    ChatListItem,
    Spinner,
    SearchInput,
    CopyButton,
    SidebarContentLoader
  },
  data () {
    return {
      value: '',
      isSubmiting: false,
      isFetched: false,
      searchQuery: '',
      text: ''
    }
  },
  computed: {
    ...mapGetters({
      chatList: 'entities/chats/myChats',
      messageById: 'entities/messages/find'
      // searchChats: 'chats/search'
    }),
    displayList () {
      return this.chatList
      // if (!this.searchQuery) return this.chatList
      // return this.searchChats(this.searchQuery)
    }
  },
  methods: {
    ...mapActions({
      sendMessage: 'entities/messages/send',
      initChats: 'entities/chats/init'
    }),
    async beforeOpen ({ params: { value = '', text = '' } }) {
      this.resetQuery()
      this.value = value
      this.text = text
      await this.initChats()
      this.isFetched = true
    },
    resetQuery () {
      this.searchQuery = ''
    },
    async send (chatId) {
      this.isSubmiting = true
      try {
        await this.sendMessage({
          chatId,
          type: TYPE_CODE.text,
          payload: this.text
        })
      } catch (e) {
        this.$modal.show('error')
      } finally {
        this.isSubmiting = false
        this.$modal.hide(this.$options.name)
      }
    }
  }
}
</script>

<style lang="scss" module>
.container {
  // padding: 20px 0;
  padding-bottom: 15px;
}
.list {
  height: 400px;
  overflow-y: scroll;
}
.spinner {
  margin-top: 20px;
}
.header {
  padding: 10px 15px;
}
.copy {
  width: 80%;
  margin: auto;
  margin-bottom: 8px;
}
</style>
